export const RayDataConstant = {
	GETALL: 'GETALL_RAYDATA',
	GET: 'GET_RAYDATA',
	CREATE: 'CREATE_RAYDATA',
	UPDATE: 'UPDATE_RAYDATA',
	DELETE: 'DELETE_RAYDATA',
	ADDUPDATE: 'ADDUPDATE_RAYDATA',
    LOADING: 'LOADING_RAYDATA',
    LOADED: 'LOADED_RAYDATA',
};